
const CategoryCard = ({ data, onView }) => {
    const { id, name, image, sequence, is_active, description } = data

    return (
        <div className="bg-eerie-black border border-zinc-700 rounded-3xl">
            <div className="p-5 space-y-4">
                <div className="flex justify-between items-start">
                    <div className="flex items-center">
                        {image && (
                            <div className="h-16 w-16 mr-4 rounded-full">
                                <img src={image} alt={name} className="h-16 w-16 rounded-full object-cover" />
                            </div>
                        )}
                        <div>
                            <h2 className="text-md font-medium">{name}</h2>
                            {id && <p className="text-sm text-zinc-500">ID: {id}</p>}
                        </div>
                    </div>
                    <button 
                        onClick={() => onView(data)}
                        className="p-3 text-zinc-500 hover:text-white border border-zinc-700 rounded-full transition-colors"
                    >
                        <svg
                            className="w-4 h-4"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                        </svg>
                    </button>
                </div>
                {description && (
                    <div className="flex flex-col space-y-1">
                        <p className="text-xs text-zinc-400">{description}</p>
                    </div>
                )}
                <div className="flex justify-between items-center">
                    <div className="flex items-center space-x-4">
                        <div className="flex items-center space-x-2">
                            <p className="text-xs text-zinc-500">SEQUENCE:</p>
                            <span className="px-3 py-1 bg-charleston-green text-xs text-white font-medium rounded">
                                {sequence || 1}
                            </span>
                        </div>
                    </div>
                    <span className={`px-4 py-1.5 text-xs rounded-full
                        ${is_active 
                            ? 'bg-green-950 text-green-500 border border-green-500' 
                            : 'bg-red-950 text-red-500 border border-red-500'}
                        `}>
                        {is_active ? "ACTIVE" : "INACTIVE"}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default CategoryCard;